/**
 * DFP Platform Functions
 * Static helper functions implementing DFP capabilities
 * version 2.3.4
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdPlatforms/dfp',[
    "jquery",
    "utilities",
    "logging",
    "AdModules/adslots",
    "performance"
], function ($, utilities, logging, adslots, performance) {
    "use strict";

    var _ModuleName = "Ad Platform [DFP]";
    var _perfMonitor = 'DFP';

    /**
     * Refresh an ad slot that's already loaded
     * @param {AdSlot} slot 
     */
    var refreshSlot = function (slot) {
        if (slot.def) {
            window.googletag.pubads().refresh([slot.def]);
        }
    }

    /**
     * Refresh several ad slots with one call
     * @param {Array<AdSlot>} slots An array of ad slot objects
     */
    var refreshSlots = function (slots) {
        window.googletag.pubads().refresh(slots.map(function (s) { return s.def; })
                                                .filter(function (s) { return typeof (s) != 'undefined' && s != {}; }));
    }

    /**
     * Refresh all ad slots
     */
    var refreshAllSlots = function () {
        window.googletag.pubads().refresh();
    }

    /**
     * Handles loading an ad slot by calling the dfp display function
     * @param {AdSlot} slot 
     */
    var loadSlot = function (slot, pageconfig) {
        if (typeof (slot) == 'undefined') {
            logging.error("Invalid Slot Configuration, unable to load slot.", _ModuleName);
            return false;
        }
        if (typeof (pageconfig) == 'undefined') {
            logging.error("Invalid Page Configuration, unable to load slot", _ModuleName);
            return false;
        }

        // Define Slot
        if (slot.outofpage) {
            adslots.defineOutOfPageSlot(slot);
        } else {
            adslots.definePageSlot(slot);
        }

        _initializeSlot(slot);

        // Mark loaded
        slot.loaded = true;

        return slot.loaded;
    }

    /**
    * Handles loading an ad slot by calling the dfp display function
    * @param {AdSlot} slot 
    */
    var loadSlots = function (slots, pageconfig) {
        var result = true;
        for (var i = 0; i < slots.length; i++) {
            var slot = slots[i];
            result = result && loadSlot(slot, pageconfig);
        }

        return result;
    }

    /**
     * Queues up the work in the DFP command queue
     * @param {function} work 
     */
    var enqueue = function (work) {
        window.googletag = window.googletag || {};
        window.googletag.cmd = window.googletag.cmd || [];

        if (typeof work == 'function') {
            window.googletag.cmd.push(work);
        } else {
            logging.error("Not a function, unable to queue work", _ModuleName);
        }
    }

    /**
     * Check if ads are disabled
     */
    var adsAreDisabled = function () {
        var disableFlag = utilities.getParameter(document.URL, "disableAds");
        return (utilities.isDevelopment() && (typeof disableFlag != 'undefined') && (disableFlag == "1" || disableFlag == "true"));
    }

    /**
     * Configures and enabled DFP Services
     */
    var enableServices = function () {
        ;

        // Disable Initial Load
        window.googletag.pubads().disableInitialLoad();

        // Enabled Single Request Mode
        window.googletag.pubads().enableSingleRequest();

        // Mark our ad reqeusts as non-child directed
        window.googletag.pubads().setTagForChildDirectedTreatment(0);

        // Enable Ads
        window.googletag.enableServices();
    }

    /**
     * Load DFP Scripts from Google
     */
    var loadScripts = function () {
        ;
        if ($('script[src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"]').length == 0) {
            var gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';
            gads.onload = _callback;
            gads.onerror = _error;
            gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
            var node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);
        } else {
            _callback();
        }
    }

    var _callback = function () {
        // register script load with performance monitor
        performance.tick(_perfMonitor, 'DFP Scripts Loaded');
    }

    /**
     * Load Configuration
     * Lets targeting information in Google Tag and defins all page slots in DFP
     * @param {pageconfig} pageconfig DFP Page configuration object
     */
    var loadConfiguration = function (pageconfig, adLoadedHandler) {
        // Set Cookie Options
        logging.log("Setting DFP Cookies: " + (pageconfig.enableCookies === 0 ? "Enabled" : "Disabled"), _ModuleName);
        window.googletag.pubads().setCookieOptions(pageconfig.enableCookies);

        // Collapse Empty Ad Positions
        window.googletag.pubads().collapseEmptyDivs(true);

        if (typeof adLoadedHandler == 'function') {
            // Attach ad loaded event handler
            window.googletag.pubads().addEventListener('slotRenderEnded', adLoadedHandler);
        }
    }

    /**
     * Calls display on an ad slot to initialize it
     * @param {AdSlot} slot object representing an ad slot
     */
    var _initializeSlot = function (slot) {
        if (slot) {
            window.googletag.display(slot.id);
        }
    }

    /**
     * Work to do after an ad slot has been loaded
     * @param {*} event 
     */
    var adDomUpdatesOnLoad = function (event) {
        var id = event.slot.getSlotElementId();
        var $slot = $('#' + id);
        if ($slot.length) {
            if (event.isEmpty) {
                logging.warn("Ad Slot id " + id + " failed to load. Response from DFP was empty.", _ModuleName);
                return;
            }

            ;

            // Add slot handling functions here

            // make sure slot is displayed
            $slot.show();

            // Have adhesion ad slide in
            if($slot.parent().hasClass('sticky')) {
                $slot.parent().addClass('slide-in');
            }

            if (utilities.IsPhone()) {
                // Ad phone only slot handling functions here

                // Center the Ad
                _centerAd($slot);
            }
        }
    }

    /**
     * Centers an ad slot on mobile device
     * @param {object} $ad jQuery object representing an ad slot  
     */
    var _centerAd = function ($ad) {
        ;

        var $container = $ad.parent();
        var fixedOffset = Math.ceil($ad.offset().left - (($(window).width() - $ad.width()) / 2.0));

        // If it's really close to center, just bail
        if (fixedOffset < 5) return;

        ;
        var styles = $container.attr('style') || '';
        $container.attr('style', styles + ';margin-left: -' + fixedOffset + 'px;');
    }

    return {
        refreshSlot: refreshSlot,
        refreshSlots: refreshSlots,
        refreshAllSlots: refreshAllSlots,
        loadSlot: loadSlot,
        enqueue: enqueue,
        adsAreDisabled: adsAreDisabled,
        enableServices: enableServices,
        loadScripts: loadScripts,
        loadConfiguration: loadConfiguration,
        loadSlots: loadSlots,
        adDomUpdatesOnLoad: adDomUpdatesOnLoad
    }
});
